<template>
  <span>

    <div v-if="searchString == ''" class="ItemTreeProject" >

      <li>
        <div   class="treeline" >
          <div class="expand__container">
          <img class="expandimage" v-if="isFolder !== undefined && open == false && model.children.length > 0" @click="toggle" src="/static/branch-collapsed.png">


          <img class="expandimage" v-if="isFolder !== undefined && open == true && model.children.length > 0" @click="toggle" src="/static/branch-expanded-dark.png">


          <img class="expandimage" v-if="!isFolder" src="/static/transparent_icon_24.png">
          </div>

        <span   v-if="model.type === folder" :class="folder"></span>
        <span v-if="model.type !== folder" class="nofolder"></span>

        <a v-if="model.type === folder" class="category__name" v-bind:class="{ active: classObject }" @click="select">{{model.name}}</a>
        <a v-if="model.type !== folder" class="category__name" v-bind:class="{ active: isActive }" @click="select">{{model.name}}</a>

          <div class="deletebutton">
          <button v-show="showDelete"
              v-b-tooltip.hover.left
              size="sm"
              type="submit"
              class=" my-2 my-sm-0 deleteButton"
              v-if="edit"
              :id="'id_'+model.categoryId"
              @click="onClickDelete(model.id)" >{{lang.button_Delete}}</button>
          </div>
        </div>

        <ul v-show="open" v-if="isFolder" class="library_ul">
          <ItemTreeProject :action="action" :searchString="searchString" class="library_item" :lang="lang" v-for="model in model.children" :model="model" :edit="edit" :key="model.categoryId"></ItemTreeProject>
        </ul>




      </li>
    </div>
    <span v-if="searchString != ''" class="ItemTree" >
      <span v-if="searchStringExist">
        <li>
          <div class="treeline" >
            <span v-if="searchStringExist">

              <span v-if="model.type === folder" :class="folder"></span>
              <span v-if="model.type !== folder" class="nofolder"></span>

              <a v-if="model.type === folder" class="category__name" v-bind:class="{ active: classObject }" @click="select" v-b-tooltip.hover.topright :title="categoryPath">{{model.name}}</a>
              <a v-if="model.type !== folder" class="category__name" v-bind:class="{ active: isActive }" @click="select" v-b-tooltip.hover.topright :title="categoryPath">{{model.name}}</a>

              <div class="deletebutton">
              <button v-show="showDelete"
                  v-b-tooltip.hover.left
                  size="sm"
                  type="submit"
                  class=" my-2 my-sm-0 deleteButton"
                  v-if="edit"
                  :id="'id_'+model.categoryId"
                  @click="onClickDelete(model.id)" >{{lang.button_Delete}}</button>
              </div>
            </span>
          </div>

        </li>

      </span>
      <span v-show="open" v-if="isFolder" class="library_ul_flat">
        
        <ItemTreeProject  :action="action" :searchString="searchString" class="library_item" :lang="lang" v-for="model in model.children" :model="model" :edit="edit" :key="model.categoryId"></ItemTreeProject>
      </span>
    </span>
  </span>
</template>

<script>



export default {
  name: 'ItemTreeProject',
  props: {
    model: Object,
    edit: Boolean,
    lang: Object,
    searchString: String,
    action: Boolean,
    
  },
  data: function () {
    return {
        open: false,
        folder: "folder",
        showDelete: false,
        categoryName: "",
        deleteButtonName: "delete-"+this.model.name,
        objAlertSuccess: {
          text: this.lang.alert_success_delete_category,
          type: "success", //success, danger, warning, info
          time: 5 //sec.

        },
        objAlertError:{
          text:this.lang.alert_error_delete_category,
          type: "danger", //success, danger, warning, info
          time: 5 //sec.
        },
        

    };
  },
  computed: {

    isFolder: function () {
      if (this.model.children == undefined){
        return
      
      }
      return this.model.children.length > 0;
    },
    isActive() {
      if (this.checkShouldBeOpened() == true) {
        this.open = true;
      }
      
              
      return this.$store.getters.selectedTreeProjectItemObject.categoryId == this.model.categoryId;
    },
    uid(){

      return this._uid
    },
    classObject(){
      return {
        active: this.isActive
      }
    },
      categoryPath() {
      let ret;
      let temp = this.model.category.split("\\")

      temp.splice(0, 1);
      ret = temp.join("\\");

      return ret;
    },
    searchStringExist() {
      let name = this.model.name.toLowerCase();

      let index = name.indexOf(this.searchString.toLowerCase());

      if (index > -1) {
        return true;

      } else {
        return false;

      }

    }


  },
  mounted () {
    if (this.model.depth == 1) {
      this.open = true;
    }
  },
  updated() {
    
  },
  watch: {
    
  },
  methods: {
    checkShouldBeOpened: function() {
      let trig = false;
      
      if (this.model.categoryId == this.$store.getters.selectedTreeProjectItemObject.categoryId) {
        
        trig = true;
      }
      
      if (trig == false) {
        if (this.model.children != undefined) {
          if (this.model.children.length > 0) {

            trig = this.checkShouldBeOpenedChild(this.model.children);
          }
        }
      }
      
      
      return trig;
    },
    checkShouldBeOpenedChild: function (children) {
      let trig = false;
      

      for (var i = 0, lei = children.length; i < lei; i++) {

        if (children[i].categoryId == this.$store.getters.selectedTreeProjectItemObject.categoryId) {
          trig = true;
          
          break;
        }

        if (trig != true) {
          if (children[i].children.length > 0) {

            trig = this.checkShouldBeOpenedChild(children[i].children);
          }
        }
        
        
      }
      return trig;
    },
    toggle: function () {
      
        if (this.isFolder) {
            this.open = !this.open;
        }


    },
    onClickDelete: function(id){

      if (this.model.category == "All projects"){
        return
      }

      
      let vue = this;
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_checkIfProjectsInCategory", {categoryId: this.model.categoryId})
      .then(function(result) {
        console.log(result)
        if (result.data > 0){
          vue.deleteWithParts(result.data);
        }else{
          vue.delete();

        }

      })
      

    },
    delete: function(){
      
      let deleteFunc = ()=>{

        const obj = {
          categoryId: this.model.categoryId, 
          objAlertSuccess: this.objAlertSuccess, 
          objAlertError: this.objAlertError 
        }
        
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteProjectCategory", obj)
        .then((result) => {
          console.log(result)
          this.$store.dispatch(this.$store.getters.sectionPrefix + "_reloadAfterDeleteTreeProjectItem", true )
        })
        

      }


      let obj = {
        title: this.lang.alerttitle_Delete,
        text: this.lang.alertinfo_1,
        type: "sure",
        buttons: 2,
        size: "sm",
        funcNo: "",
        funcYes: deleteFunc
      };
      this.$store.dispatch("showAlert", obj);
    },
    deleteWithParts: function(qty){
      
      
      // let deleteFunc = ()=>{
      //   const obj = {
      //     categoryId: this.model.categoryId, 
      //     objAlertSuccess: this.objAlertSuccess, 
      //     objAlertError: this.objAlertError 
      //     }
      //   this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteProjectCategory", obj)
      //   .then((result) => {
      //     console.log(result)
          
      //     this.$store.dispatch(this.$store.getters.sectionPrefix + "_reloadAfterDeleteTreeProjectItem", true )
      //   })
        

      // }
      let str = qty + " projects";
      if (qty == 1){
        str = qty + " project";
      }
      
      let obj = {
        title: this.lang.alerttitle_Delete,
        text: this.lang.alertinfo_2 + str +". " + this.lang.alertinfo_3,
        type: "sure",
        buttons: 1,
        size: "sm",
        funcOk: ""
      };
      
      this.$store.dispatch("showAlert", obj);
    },
    select: function () {
      

      this.categoryName = this.model.categoryId === 1 ? "" : this.model.name;
      let buttons = document.querySelectorAll(".deleteButton");

      for(let button of buttons){
        let id = "id_" + this.model.categoryId;
        if(button.id === id && button.id !== 1){
          button.style.display="block";
          

        }
        if(id !== button.id){
        button.style.display="none";

        }
          
      }



      this.$store.dispatch(this.$store.getters.sectionPrefix + '_selectTreeProjectItem', this._uid);
      
      this.$store.dispatch(this.$store.getters.sectionPrefix + '_selectTreeProjectItemObject', this.model);

      if (this.action == true){
        
        this.$store.dispatch(this.$store.getters.sectionPrefix + '_setElementCategoryProject', this.model.category);
        
      }

    },
    changeType: function () {
        if (!this.isFolder) {
            Vue.set(this.model, 'children', []);
            this.addChild();
            this.open = true;
        }
    }

  }
}
</script>


<style lang="scss">

  .ItemTreeProject{
    li {
      width: fit-content;
    }
    .expandimage {
      width: 16px;
      height: 16px;
      margin-left: 5px;
    }
    .expand__container{
      width:20px;
      height: 15px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      flex-direction: column;
    }
    .library_item {
      cursor: pointer;

    }
    .library_ul {
      padding-left: 18px;
      line-height: 1.5em;
      list-style-type: none;

    }
    .library_ul_flat {
      padding-left: 0px;
      line-height: 1.5em;
      list-style-type: none;

    }
    .deleteButton{
      margin-left: 5px;
      border-radius: 3px;
      border: 1px solid white;
    }
    .category__name{
      cursor: pointer;

    }
    .folder{
      background-image: url("/static/folder.svg");
      width: 19px;
      height: 16px;
      display: block;
      margin-right: 10px;
    }
    .nofolder{
        background-image: url("/static/folder.svg");
        width: 19px;
        height: 16px;
        display: block;
        margin-right: 10px;
        float: left;
    }

    .treeline{
      display: inline-flex;

    }

    a{
      padding-right: 10px;
      padding-left: 10px;
    }

  }



</style>



// WEBPACK FOOTER //
// src/components/shared/ItemTreeProject.vue